jQuery(document).ready(function() {

  console.log("reacffdy!");
  var hash = document.location.hash;
  
  if(hash) {
    var activeTab = hash;

    console.log(activeTab);
  
    $(".single-manuals section").removeClass('active');
    $(".single-manuals section").removeClass('show');
  
    $(activeTab).addClass('active');
    $(activeTab).addClass('show');
  
    $(".single-manuals .nav-tabs a").removeClass("active");
    $(".single-manuals .nav-tabs a[href^='"+activeTab+"']").addClass("active");
  }

  $(".single-manuals .nav-tabs a").click(function() {
    window.location.hash = $(this).attr("href");
  });

});

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
          var pair = vars[i].split("=");
          if(pair[0] == variable){
            // remove weird character bugs
            pair[1] = pair[1].replace('%24', '');
            pair[1] = pair[1].replace('$', '');
            pair[1] = pair[1].replace('{Specifications%20Manual%20Qty%20(Quantity):8.3}', '');
            pair[1] = pair[1].replace('{Specifications%20Manual%20Qty%20(Price):8.2}', '');
            pair[1] = pair[1].replace('{Specifications%20Manual%20Qty%20(Quantity):11.3}', '');
            pair[1] = pair[1].replace('{Specifications%20Manual%20Qty%20(Price):11.2}', '');
            return pair[1];
          }
  }
  return(false);
}

// submitting CC payment form

if( $('#manualConfirmation').length ) {

  var payment_total = 0.00;

  // totalling up all pricing variables
  
  if(getQueryVariable('sponsordesignprice') != '' && getQueryVariable('sponsordesignqty') != '') {
    payment_total = payment_total + (getQueryVariable('sponsordesignqty') * parseFloat(getQueryVariable('sponsordesignprice')));
    console.log("A:"+payment_total);
  }
  if(getQueryVariable('sponsorspecprice') != '' && getQueryVariable('sponsorspecqty') != '') {
    payment_total = payment_total + (getQueryVariable('sponsorspecqty') * parseFloat(getQueryVariable('sponsorspecprice')));
    console.log("B:"+payment_total);
  }
  if(getQueryVariable('nondesignprice') != '' && getQueryVariable('nondesignqty') != '') {
    payment_total = payment_total + (getQueryVariable('nondesignqty') * parseFloat(getQueryVariable('nondesignprice')));
    console.log("C:"+payment_total);
  }
  if(getQueryVariable('nonspecprice') != '' && getQueryVariable('nonspecqty') != '') {
    payment_total = payment_total + (getQueryVariable('nonspecqty') * parseFloat(getQueryVariable('nonspecprice')));
    console.log("D:"+payment_total);
  }
  
  payment_total = payment_total.toFixed(2);

  // add to confirmation page

  $('#totalAmount').html('$' + payment_total);

  console.log(payment_total);

  $('#totalPrice').html('$' + payment_total);

  if( $('#manualpaymentform').length != 0 && getQueryVariable('payment') == 'Credit+Card'){

    var callback_url = window.location.href;
  
    document.manualpaymentform.AMT.value = payment_total;
    document.manualpaymentform.SUCCESS_LINK.value = callback_url;
    $('#manualpaymentform').submit();
  }
}


// WEBPACK FOOTER //
// ./scripts/routes/manuals.js